import { createSelector } from 'reselect';

const uiSelector = state => state.ui;
const topifyPresetsSelector = state => state.topifyPresets;
const userStateSelector = state => state.ustate;

export default createSelector(
	[ uiSelector, topifyPresetsSelector, userStateSelector ],
	( ui, topifyPresets, ustate ) => {
		return {
			userSettings: ui.userSettings,
			siteTitle: topifyPresets.forumSite.f_title,
			ustate: ustate
		}
	}
);



// WEBPACK FOOTER //
// ./src/selectors/settingsSelector.js